import NewMainVerify from '@comp/NewVerify/newVerifyMain';
import CustomFailed from '@root/components/CustomFailed';
import CustomSuccess from '@root/components/CustomSuccess';
import {
  formVerifyData,
  getAcreditContentData
} from '@root/constants/formData';
import {
  aCreditVerify,
  aCreditVerifyFailed,
  aCreditVerifySuccess
} from '@root/constants/paths';
import icon from '@root/images/acredit/logo.png';

const { main } = getAcreditContentData();

export const getACreditVerifyRoutes = () => [
  {
    path: aCreditVerify(),
    element: (
      <NewMainVerify
        mainContent={main}
        formData={formVerifyData}
        merchantIcon={icon}
        redirectPaths={{
          success: aCreditVerifySuccess,
          failed: aCreditVerifyFailed
        }}
      />
    )
  },
  {
    path: aCreditVerifySuccess(),
    element: <CustomSuccess />
  },
  {
    path: aCreditVerifyFailed(),
    element: <CustomFailed />
  }
];
